import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});



class VideoChat extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    this.state = {};
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Contact Us';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openVideoChat() {
    acquireIO.max('video');
  }

	render() {
		return <div className='VideoChat'>
			<div className='scheduleHeader'>Live Video Chat</div>
			<div className='scheduleBody'>
        <div className='scheduleBr'></div>
        <div className='vidWrapper'>
          <div className='vidLeftCol'>
            <img src='https://ddw2.diamondsdirect.com/img/contact/live_video.jpg' />
          </div>
          <div className='vidRightCol'>
            <div className='vidTitle'>Welcome to Diamonds Direct Live Video Chat!</div>
            <div className='vidP'>Diamonds Direct Live Video is a one-of-a-kind experience that connects you face-to-face with a live diamond expert. Whether it's from the comfort of your home, office, or even the coffee shop, our diamond experts have the tools to help you make the right decision.</div>
            <div className='vidButton' onClick={::this.openVideoChat}><div>Click Here to Speak to an Expert by Video Call</div></div>
            <div className='vidP'>When prompted, please allow access to your webcam and microphone for the optimal video chat experience.</div>
            <div className='vidLegal'>We have experts available to connect Monday through Saturday from 10am to 6pm.</div>
          </div>
          <div className='vidMobileImg'>
            <img src='https://ddw2.diamondsdirect.com/img/contact/live_video.jpg' />
          </div>
        </div>
			</div>
      <div className='scheduleFooterSpacer'></div>
		</div>;
	}
}
export default VideoChat;

function mapStateToProps(state) {
  return {

  };
}

export const VideoChatContainer = connect(
  mapStateToProps,
  allActionCreators
)(VideoChat);


// WEBPACK FOOTER //
// ./src/components/views/contact/VideoChat.jsx